'use client'

import {
  ConversationMessageType,
  ConversationMessage as ConversationMessageProps,
  StatusMessage as StatusMessageType,
  Message as MessageType,
  TransactionSide,
} from '@marketplace-web/domain/conversation-messaging-data'
import {
  OfferMessage as OfferMessageType,
  OfferRequestMessage as OfferRequestMessageType,
} from '@marketplace-web/domain/price-offers-data'
import { OfferMessage, OfferRequestMessage } from '@marketplace-web/domain/price-offers'

import StatusMessage from '../StatusMessage'
import ReportSuggestion from '../ReportSuggestion'
import UserMessage from '../UserMessage'
import useTransactionActions from '../../../hooks/useTransactionActions/useTransactionActions'

type Props = ConversationMessageProps & {
  userSide: TransactionSide
  transactionId?: number
  isGrouped: boolean
  isLast: boolean
  isCurrentAuthor: boolean
  conversationId: string | number | undefined
  toggleSidebar?: () => void
  openOfferModal: () => void
}

const ConversationMessage = ({ conversationId, ...props }: Props) => {
  const { entityType, message } = props
  const { applicableTransactionActions } = useTransactionActions()

  switch (entityType) {
    case ConversationMessageType.ActionMessage:
    case ConversationMessageType.StatusMessage:
      return <StatusMessage {...props} message={message as StatusMessageType} />
    case ConversationMessageType.ReportSuggestion:
      return <ReportSuggestion conversationId={conversationId} />
    case ConversationMessageType.OfferMessage:
      return <OfferMessage {...props} message={message as OfferMessageType} />
    case ConversationMessageType.OfferRequestMessage:
      return (
        <OfferRequestMessage
          {...props}
          message={message as OfferRequestMessageType}
          applicableTransactionActions={applicableTransactionActions}
        />
      )
    case ConversationMessageType.Message:
    case ConversationMessageType.PortalMessage:
      return <UserMessage {...props} message={message as MessageType} />
    default:
      return null
  }
}

export default ConversationMessage
